export default __webpack_public_path__ + "2e78e5d6553101a653ef17ce6c725aef.png";